import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { API } from '@/App';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      const response = await axios.get(`${API}/payments/status/${sessionId}`);
      setStatus(response.data);
    } catch (error) {
      console.error('Failed to check payment status', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p>Verifying your payment...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-6 py-20">
        <div className="glass-card p-12 rounded-lg text-center" data-testid="payment-success-card">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          
          <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Cabinet Grotesk' }} data-testid="payment-success-title">
            Payment Successful!
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8" data-testid="payment-success-message">
            Your booking has been confirmed. We've sent the details to your email.
          </p>

          {status && (
            <div className="bg-muted p-6 rounded-lg mb-8 text-left">
              <h3 className="font-bold mb-3">Booking Details</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Session ID:</span>
                  <span className="font-mono" data-testid="payment-session-id">{sessionId?.substring(0, 20)}...</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Status:</span>
                  <span className="font-semibold text-green-600" data-testid="payment-status">{status.payment_status}</span>
                </div>
              </div>
            </div>
          )}

          <div className="flex gap-4 justify-center">
            <Link to="/dashboard" data-testid="payment-success-dashboard-btn">
              <Button className="btn-primary">
                View My Bookings
              </Button>
            </Link>
            <Link to="/cars" data-testid="payment-success-browse-btn">
              <Button variant="outline">
                Browse More Cars
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentSuccessPage;
